import { Sentry } from "../../analytics/Sentry";
import { ILogger } from "./ILogger";
import { LogLevel } from "./LogLevel";

export class SentryLogger implements ILogger {
    public readonly ignoreLevels: ReadonlyArray<LogLevel>;
    private readonly sentry: Sentry;

    public constructor(sentry: Sentry, ignoreLevels?: Array<LogLevel>) {
        this.sentry = sentry;
        this.ignoreLevels = ignoreLevels;
    }

    public debug(message: string): void {
        this.internalLog(message, LogLevel.Debug);
    }

    public info(message: string): void {
        this.internalLog(message, LogLevel.Warn);
    }

    public warn(message: string): void {
        this.internalLog(message, LogLevel.Warn);
    }

    public event(message: string, attachments?: Record<string, string>): void {
        this.sentry.sendEvent(message, attachments);
    }

    private internalLog(message: string, logLevel: LogLevel): void {
        if (this.ignoreLevels.includes(logLevel)) {
            return;
        }

        switch (logLevel) {
            case LogLevel.Debug:
                this.sentry.sendDebug(message);
                break;
            case LogLevel.Info:
                this.sentry.sendInfo(message);
                break;
            case LogLevel.Warn:
                this.sentry.sendWarning(message);
                break;
        }
    }

    public error(message?: string): void
    public error(exception?: unknown): void
    public error(message: string, exception?: unknown): void {
        if (this.ignoreLevels.includes(LogLevel.Error)) {
            return;
        }
        this.sentry.sendError(exception instanceof Error ? exception : new Error(message));
    }

}